/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterDayviewCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterDayviewCtrl', ["dialog", "$scope", function(dialog, $scope) {
  var MINUTES_PER_DAY = 1440;

  $scope.segments = [];
  $scope.unavailability = $scope.unavailability || [];
  $scope.leaveRequests = $scope.leaveRequests || [];
  var totalSegments = 12;
  var increment = MINUTES_PER_DAY / totalSegments;

  for (var i = 0; i < totalSegments; i++) {
    var labelFormat = (moment($scope.viewStartDateTime).minutes() === 0) ? 'hA' : 'h:mmA';

    $scope.segments.push({
      startTime: moment($scope.viewStartDateTime).add(increment * i, 'minutes'),
      time: moment($scope.viewStartDateTime).add(increment * i, 'minutes').format(labelFormat)
    });
  }

  var updateView = function() {
    $scope.shifts = {};
    $scope.dayUnavailability = {};
    $scope.dayLeaveRequests = {};
    angular.forEach($scope.staff, function(staff) {
      $scope.shifts[staff.id] = [];

      $scope.dayUnavailability[staff.id] = [];
      $scope.dayLeaveRequests[staff.id] = [];
    });

    // Build a list of shifts that should be shown on the requested day - the
    // rosteredShifts variable holds all shifts for the full roster week.
    angular.forEach($scope.rosteredShifts, function(rosteredShift) {
      // We only want to show shifts that fall within the date range the view is
      // presenting. This handles company days, e.g. a shift starting after
      // midnight and before the company start time is expected to be presented
      // on the previous calendar day. E.g. a shift at 3am Monday morning for a
      // company with a 7am company start time should show on the Sunday day view.
      if ($scope.isInViewDateRange(rosteredShift.clockinTime)) {
        $scope.shifts[rosteredShift.staffMemberId].push(rosteredShift);
      }
    });

    // Add unavailability objects to the list to be displayed on the day view.
    $scope.unavailability.forEach(record => {      
      // Check if the unavailability record belongs to a deactivated staff member
      // If the staff member is deactivated, their unavailability should not be displayed
      if (!$scope.unavailabilityVisible || !$scope.shifts[record.staffMemberId]) {
        return;
      }

      var reportStartDate = moment($scope.viewStartDateTime).format('YYYY-MM-DD')
      // Check if the unavailability is valid for the current day. Skip the record if it is not.
      if (record.from > reportStartDate || (record.to && record.to < reportStartDate)) {
        return;
      }

      // One off unavailability, we use the date on the record and the time
      // directly
      if (record.type == 'OneOff') {
        record.times.forEach(time => {
          $scope.dayUnavailability[record.staffMemberId].push({
            id: time.id,
            type: record.type,
            reason: time.reason,
            status: record.status,
            startTime: moment([record.from, 'T', time.from].join('')),
            endTime: moment([record.to, 'T', time.to].join('')),
          });
        })
      }

      // Weekly unavailability, we use the day on the time object to work
      // out if it matches the day we're displaying
      if (record.type == 'Weekly') {
        record.times.forEach(time => {

          const viewStartDateTimeMoment = moment($scope.viewStartDateTime)

          if (time.day == viewStartDateTimeMoment.format('dddd')) {

            const startDate = viewStartDateTimeMoment.format('YYYY-MM-DD')

            $scope.dayUnavailability[record.staffMemberId].push({
              id: time.id,
              type: record.type,
              reason: time.reason,
              status: record.status,
              startTime: moment([startDate, 'T', time.from].join('')),
              endTime: moment([startDate, 'T', time.to].join('')),
            });
          }
        })
      }

    });

    if ($scope.leaveRequestsVisible) {
      // Add leave objects to the list to be displayed on the day view.
      $scope.leaveRequests.forEach(leave => {

        // Check if the leave record belongs to a deactivated staff member
        // If the staff member is deactivated, their leave should not be displayed
        if (!$scope.leaveRequestsVisible || !$scope.shifts[leave.staffMemberId]) {
          return;
        }

          
        $scope.dayLeaveRequests[leave.staffMemberId].push({
          id: leave.id,
          type: leave.type,
          reason: leave.reason,
          status: leave.status,
          startTime: moment(leave.startDateTime),
          endTime: moment(leave.endDateTime),
        });
      });
    }
  };

  updateView();

  $scope.$watch('[unavailabilityVisible, leaveRequestsVisible]', function() {
    updateView();
  });

  $scope.updateShift = function(updatedShift) {
    $scope.baseUpdateShift(updatedShift)
    .then(function() {
      updateView();
    });
  };

  /**
   * Called from the cellday/cellweek directives when a shift is created.
   * The newShift object is created in there and passed to this function.
   * @param {*} newShift 
   */
  $scope.createShift = function(newShift) {
    $scope.shifts[newShift.staffMemberId].push(newShift);

    $scope.baseAddShift(newShift)
    .then(function() {
      updateView();
    });
  };

  $scope.setSort = function(newSortCol) {

    if (newSortCol === 'name') {
      // Simple alphabetical sort based on staff member name.
      $scope.staff
        .sort(function(a, b) {
          return a.name < b.name ? -1 : 0;
        });

    } else {

      var withShifts = [];
      var withoutShifts = [];

      // Gather two sets, those staff with shifts and those without.
      angular.forEach($scope.staff, function(staffMember) {
        if ($scope.shifts[staffMember.id].length > 0) {
          withShifts.push(staffMember);
        } else {
          withoutShifts.push(staffMember);
        }
      });

      // Sort the staff members with shifts into order based on the chosen time
      // the user want's to order by.
      //
      // We sort by the start time of the shift for all staff members that have
      // a shift that finishes after the selected time, those staff members that
      // only have an earlier shift get alphabetically ordered below the staff
      // members with shifts that are within the desired range.
      withShifts
        .sort(function(a, b) {

          // Find the first shift for the staff members we're comparing that
          // starts after the selected order by time.
          var aShift = $scope.shifts[a.id].find(function(shift) {
            return moment(shift.clockoutTime).isAfter($scope.segments[newSortCol].startTime);
          });

          var bShift = $scope.shifts[b.id].find(function(shift) {
            return moment(shift.clockoutTime).isAfter($scope.segments[newSortCol].startTime);
          });

          // If the staff member only has a shift that finishes before the
          // sorting column time then we order alphabetically based on their
          // name. Due to how string comparison works a name will sort after
          // a datetime, meaning the staff members without shifts in the selected
          // order by time period will go after all staff members with shifts,
          // and they'll be alphabetically ordered too...
          var aClockinTime = aShift ? aShift.clockinTime : a.name;
          var bClockinTime = bShift ? bShift.clockinTime : b.name;

          if (aClockinTime < bClockinTime) {
            return -1;
          }

          if (aClockinTime === bClockinTime) {
            return a.name < b.name ? -1 : 0;
          }

          return 1;
        });

      withoutShifts
        .sort(function(a, b) {
          return a.name < b.name ? -1 : 0;
        });

      $scope.staff = withShifts.concat(withoutShifts);

    }
  };

  $scope.openEditDialog = function(data) {
    $scope.showShiftEditorDialog(data)
    .then(function(updatedShift) {
      if (updatedShift.deleted) {
        $scope.baseDeleteShift(updatedShift)
        .then(function() {
          updateView();
        });
      } else if (updatedShift.id) {
        $scope.updateShift(updatedShift);
      } else {
        $scope.createShift(updatedShift);
      }
    });
  };

  $scope.reassignShifts = function(staffMember) {
    dialog.open({
      templateUrl: 'modules/time/roster/reassignShifts.tpl.html',
      controller: 'TimeRosterReassignShiftsCtrl',
      size: 'md',
      scope: $scope,
      resolve: {
        staffMember: staffMember
      }
    });
  };
}]);
